import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userWrapper: {
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '96px',
    width: '100%',
    padding: '8px',
    gap: '8px',
    border: `1px solid ${theme.palette.background.paper}`,
    transition: 'border 0.3s ease',
    boxShadow: `0 1px 3px rgba(0, 0, 0, 0.1)`,

    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
  },

  avatarWrapper: {
    minWidth: '100px',
  },

  userDetails: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },

  infoWrapper: {
    flex: '1',
  },

  infoName: {
    fontWeight: '600',
  },

  controlWrapper: {
    display: 'flex',
    gap: '8px',
    //justifyContent: 'flex-end',
  },

  userWrapperAdjacent: {
    marginTop: '8px',
  },
}));
